module.exports = __webpack_public_path__ + "static/about-us-16-583e53a5601369fdbcd688f98b18cd33.jpg";